import styled from 'styled-components';
import JournalPagination from '../journal/JournalPagination';

const ActiveBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 0.65rem;
  margin-bottom: 1rem;
`;

const Chip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0.35rem 0.75rem;
  border: 1px solid ${({ theme }) => theme.colors.champagneDark};
  background: hsla(38, 48%, 94%, 0.85);
  font-size: clamp(10px, 0.12vw + 9px, 12px);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  cursor: pointer;
  font-family: inherit;
  color: ${({ theme }) => theme.colors.foreground};
  transition: background 0.2s ease, border-color 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.secondary};
    border-color: ${({ theme }) => theme.colors.foreground};
  }
`;

const ChipX = styled.span`
  opacity: 0.55;
  font-size: 14px;
  line-height: 1;
`;

const FilterTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  gap: clamp(6px, 0.8vw, 10px);
  padding: clamp(8px, 1vw, 12px) clamp(14px, 1.6vw, 20px);
  font-size: clamp(11px, 0.16vw + 10px, 13px);
  letter-spacing: 0.12em;
  text-transform: uppercase;
  font-weight: 500;
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.background};
  cursor: pointer;
  font-family: inherit;
  color: ${({ theme }) => theme.colors.foreground};
  transition: border-color 0.22s ease, box-shadow 0.22s ease;

  & svg {
    width: clamp(14px, 0.35vw + 12px, 17px);
    height: clamp(14px, 0.35vw + 12px, 17px);
  }

  &:hover {
    border-color: ${({ theme }) => theme.colors.noir};
    box-shadow: 0 3px 14px hsla(25, 15%, 20%, 0.06);
  }
`;

const CountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.15rem;
  height: 1.15rem;
  padding: 0 4px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;
  background: ${({ theme }) => theme.colors.terracottaDark};
  color: ${({ theme }) => theme.colors.cream};
`;

export function ShopActiveFilterChips({ chips, onRemove, clearAllLabel, onClearAll }) {
  if (!chips.length) return null;
  return (
    <ActiveBar>
      {chips.map((c) => (
        <Chip key={c.key} type="button" onClick={() => onRemove(c.key)}>
          {c.label}
          <ChipX aria-hidden>×</ChipX>
        </Chip>
      ))}
      {onClearAll ? (
        <Chip type="button" onClick={onClearAll} style={{ background: 'transparent' }}>
          {clearAllLabel}
        </Chip>
      ) : null}
    </ActiveBar>
  );
}

export function ShopFilterTrigger({ activeCount, onClick, label, icon: Icon }) {
  return (
    <FilterTrigger type="button" onClick={onClick}>
      {Icon ? <Icon strokeWidth={1.75} aria-hidden /> : null}
      {label}
      {activeCount > 0 ? <CountBadge>{activeCount}</CountBadge> : null}
    </FilterTrigger>
  );
}

export function ShopCatalogPagination(props) {
  return <JournalPagination {...props} />;
}
